"use client";
import { useMemo } from "react";

import { type NavPoint, NavPointTypes } from "@redux/navPoint/NavPoint";
import { UserState } from "@redux/reducers/user";
import useHash from "../../../app/_lib/hooks/useHash";

export default function useShowSuperNav(navPoint: NavPoint, user: UserState) {
  const currentHash = useHash();
  return useMemo(() => {
    if ((navPoint?.type === NavPointTypes.Portal || navPoint?.kit) && currentHash === "#configure")
      return false;
    if (navPoint?.type === NavPointTypes.UserSettings) return true;
    if (navPoint?.type === NavPointTypes.NewSpace) return true;
    return Boolean(user?.id);
  }, [currentHash, navPoint?.kit, navPoint?.type, user?.id]);
}
